import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import i18n from "../../../constants/i18n";
import Et3CustomizedButton from "../../../core/et3-button/Et3CustomizedButton";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Image from "../../../core/et3-Image";
import {
  SURFACE_BORDER,
  SURFACE_RADIUS_CSS
} from "../../../core/et3-theme/surface-constants";
import getApprovalViewerStore from "../../../stores/approval-reject-store/approval-viewer-store";
import {
  PICTURE_VIEWER_CLOSE_BOX,
  PICTURE_VIEWER_CLOSE_ICON,
  PICTURE_VIEWER_PADDING,
  PICTURE_VIEWER_SIZE,
  PICTURE_VIEWER_TOP,
  PICTURE_VIEWER_WIDTH,
  PICTURE_VIEWER_Z_INDEX
} from "./approval-data-constants";

const ApprovalPictureViewer = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const viewerStore = getApprovalViewerStore();

  return viewerStore.isVisible() ? (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={PICTURE_VIEWER_WIDTH}
      height={0}
      fDirection="row"
      alignItems="flex-start"
      justifyContent="center"
      color={colors.all.transparent}
      style={{
        position: "absolute",
        top: PICTURE_VIEWER_TOP * unitY,
        zIndex: PICTURE_VIEWER_Z_INDEX
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={true}
        width={0}
        height={0}
        fDirection="column"
        alignItems="flex-end"
        justifyContent="flex-start"
        color={colors.all.white}
        style={{
          boxSizing: "border-box",
          width: "auto",
          minWidth: 0,
          border: SURFACE_BORDER,
          borderRadius: SURFACE_RADIUS_CSS,
          padding: PICTURE_VIEWER_PADDING * unitX,
          gap: PICTURE_VIEWER_PADDING * unitY
        }}
        onClick={() => {}}
      >
        <Et3CustomizedButton
          isEnabled={true}
          withShadow={false}
          width={PICTURE_VIEWER_CLOSE_BOX}
          height={PICTURE_VIEWER_CLOSE_BOX}
          fDirection="row"
          alignItems="center"
          justifyContent="center"
          color={colors.all.transparent}
          style={{ cursor: "pointer" }}
          onClick={() => viewerStore.closePicture()}
        >
          <FontAwesomeIcon
            icon={faXmark}
            color={colors.all.davysGrey}
            title={i18n.get("CLOSE_PICTURE")}
            style={{
              width: PICTURE_VIEWER_CLOSE_ICON * unitX,
              height: PICTURE_VIEWER_CLOSE_ICON * unitY
            }}
          />
        </Et3CustomizedButton>
        <Et3Image
          type="ONLINE"
          alt={i18n.get("PICTURE")}
          imageName={viewerStore.pictureSource.get()}
          size={PICTURE_VIEWER_SIZE}
          onClick={() => {}}
          style={{ borderRadius: SURFACE_RADIUS_CSS }}
        />
      </ET3Div>
    </ET3Div>
  ) : null;
});
export default ApprovalPictureViewer;
